import React from "react";
import { CountDownTimerProps } from "./countDownTimer.types";
import { timeUnits } from "../../../utils/constants";
import clsx from "clsx";

const CountDownTimer: React.FC<CountDownTimerProps> = ({ timeLeft, isTimeAlmostOver }) => {
  if (!timeLeft) return null;

  return (
    <div
      className="text-center w-full md:rounded-b-none rounded-b-[16px] pt-[10px] pb-2"
      style={{
        background:
          timeLeft.asSeconds() <= 0
            ? "rgba(144, 168, 193, 0.15)"
            : "linear-gradient(0deg, rgba(0, 0, 0, 0.52), rgba(0, 0, 0, 0.52)), #FD3E4E"
      }}>
      <p className="text-lg font-semibold">
        {timeUnits.map((timeUnit, index) => {
          const prevUnitValue = timeUnits[index - 1]
            ? timeUnits[index - 1]?.unit === "days"
              ? Math.floor(timeLeft.asDays())
              : timeLeft[timeUnits[index - 1]?.unit]()
            : 0;
          const unitValue = Math.max(timeUnit.unit === "days" ? Math.floor(timeLeft.asDays()) : timeLeft[timeUnit.unit](), 0);
          return (
            <span
              key={index}
              className={clsx(
                "inline-block leading-[12px] items-center justify-center me-2 w-[40px] h-[20px] bg-black/50 rounded-[4px] p-1 font-semibold font-secondary text-sm text-base-white",
                isTimeAlmostOver && (unitValue !== 0 || prevUnitValue !== 0) && "text-primary-l2",
                prevUnitValue === 0 && unitValue === 0 && "text-gray-500 text-opacity-70"
              )}>
              <span
                className={clsx(
                  "font-medium text-base-white",
                  isTimeAlmostOver && (unitValue !== 0 || prevUnitValue !== 0) && "text-primary-l2",
                  prevUnitValue === 0 && unitValue === 0 && "text-gray-500 text-opacity-70"
                )}>
                {String(unitValue).padStart(2, "0")}
              </span>
              <span className="font-normal">{timeUnit.label}</span>
            </span>
          );
        })}
      </p>
    </div>
  );
};

export default CountDownTimer;
